import httpApiCall from "./api.service";
import { accessTokenLogin, getStorageValue } from "./shared.service";
import toastr from "../components/elements/toast";

const toastrService = new toastr(true);

export const openStripeOnBoarding = async () => {
  try {
    const token = getStorageValue("partnerToken");
    const body = { access_token: token };

    const responseData = await httpApiCall({
      api: "create_acc_link",
      type: "post",
      body,
    });

    if (responseData && !responseData.is_error) {
      window.location.href = responseData.url;
    } else {
      toastrService.showError(responseData.original_text || responseData.err);
      return false;
    }
  } catch (error) {
    toastrService.showError(error);
    return false;
  }
};

export const AddBankAccountOnboarding = async (stripeAccountId: any) => {
  try {
    const token = getStorageValue("partnerToken");
    const body = {
      access_token: token,
      stripe_account_id: stripeAccountId,
    };

    const OnboardingReponse = await httpApiCall({
      api: "add_bank_account_onboarding",
      type: "post",
      body,
    });
    if (
      !OnboardingReponse.is_error &&
      OnboardingReponse.data &&
      OnboardingReponse.data.bank_account
    ) {
      const partnerData = await accessTokenLogin();
      toastrService.showSuccess("Bank added successfully");
      return partnerData;
    } else {
      toastrService.showError(
        OnboardingReponse.original_text || OnboardingReponse.err
      );
    }
  } catch (error) {
    toastrService.showError(error);
  }
};
